import { useState, useEffect } from 'react';
import { CheckCircle2, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useRcsConfig, useUpsertRcsConfig, useRegisterRcsWebhook } from '@/hooks/useRcs';

export function RcsConfigForm() {
  const { data: existing, isLoading } = useRcsConfig();
  const { mutate: upsert, isPending: saving } = useUpsertRcsConfig();
  const { mutate: registerWebhook, isPending: registering } = useRegisterRcsWebhook();

  const [agentId, setAgentId] = useState('');

  useEffect(() => {
    if (existing) setAgentId(existing.agentId);
  }, [existing]);

  function handleSave() {
    if (!agentId.trim()) return;
    upsert({ agentId: agentId.trim() });
  }

  if (isLoading) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Agente RCS</CardTitle>
        <CardDescription>
          Identificador do agente RCS cadastrado na Zenvia. A autenticação usa o mesmo token da
          credencial Zenvia já configurada em Credenciais.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {existing && (
          <div className="flex items-center gap-2 rounded-md bg-green-50 px-3 py-2 text-sm text-green-700 dark:bg-green-900/20 dark:text-green-400">
            <CheckCircle2 className="h-4 w-4 shrink-0" />
            Agente configurado · última atualização{' '}
            {new Date(existing.updatedAt).toLocaleDateString('pt-BR')}
          </div>
        )}

        <div className="space-y-2">
          <Label htmlFor="rcs-agent-id">Agent ID *</Label>
          <Input
            id="rcs-agent-id"
            placeholder="agente-rcs-123"
            value={agentId}
            onChange={(e) => setAgentId(e.target.value)}
          />
        </div>

        <div className="flex gap-2">
          <Button onClick={handleSave} disabled={saving || !agentId.trim()}>
            {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Salvar
          </Button>
          {existing && (
            <Button variant="outline" onClick={() => registerWebhook()} disabled={registering}>
              {registering && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              Registrar webhook na Zenvia
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
